import React from "react";
import InstancesList from "./InstancesList/InstancesList";
import "./IntegrationDetails.scss";
import { AlertIndicator } from "../../design-system/components";
import { alertTypes } from "../../design-system/components/AlertIndicator/AlertIndicator";
import classnames from "classnames";

export interface IntegrationDetailsIntegration {
  name?: string;
}

interface IntegrationDetailsProps {
  instances?: React.ReactNode;
  mutateAllowed?: boolean;
  integrationDetailsAlertText?: string;
  fullWidth?: boolean;
  currentIntegration?: IntegrationDetailsIntegration;
}

const IntegrationDetails: React.FC<IntegrationDetailsProps> = ({
  instances,
  mutateAllowed,
  integrationDetailsAlertText,
  fullWidth = false,
  currentIntegration,
}) => {
  return (
    <div
      className={classnames("integration-details-wrapper", {
        "is-full-width": fullWidth,
      })}
    >
      {integrationDetailsAlertText && (
        <AlertIndicator
          type={alertTypes.INFO}
          content={integrationDetailsAlertText}
          wrapperClassName="integration-details-alert"
        />
      )}
      <InstancesList
        mutateAllowed={mutateAllowed}
        currentIntegration={currentIntegration}
      >
        {instances}
      </InstancesList>
    </div>
  );
};

export default IntegrationDetails;
